
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   SCVISUAL_ACTION, 
   ALL_SCVISUAL,
   FETCH_SCYEAR,
   SC_VISUALISATION_DETAILS,
   SC_CREATE_VISUALISATION,
   SC_VISUALISATION_DELETE
} from 'Actions/types';

/**
 * MSK Visualisation 
 */
export const allSCVisualisation = (id) => async (dispatch) => {    
    
    var payload={
		"studentid":id
	}
	
	dispatch({ type: SCVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/fetchscvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: ALL_SCVISUAL, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
	}); 

}


export const studentSCYears = (studentid) => async (dispatch) => {
	
	var payload={
		"studentid":studentid
	}
	
	  dispatch({ type: SCVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/studentscyears', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: FETCH_SCYEAR, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const scVisualisationDetails = (studentid, year, assessment, id) => async (dispatch) => {
	
	var payload={
		"oid":id,
		"studentid":studentid,
		"year": year,
		"assessment" : assessment
	}
	
	  dispatch({ type: SCVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/scvisualisationdetails', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;		
                var resval=resdata.data;
				dispatch({ type: SC_VISUALISATION_DETAILS, payload:resval}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const creatSCVisualisation = (mskstate, studentid, year, assessment, id) => async (dispatch) => {
	
	var payload={
		"oid":id,
		"studentid":studentid,
		"year": year,
		"assessment" : assessment,
		"summary_notes":mskstate.target.summary_notes.value,
		"clubhd_impression":mskstate.target.clubhd_impression.value,
		"clubhdshrtgoal1":mskstate.target.clubhdshrtgoal1.value,
		"clubhdlonggoal1":mskstate.target.clubhdlonggoal1.value,
		"clubhd_approach":mskstate.target.clubhd_approach.value
	}
	
	  dispatch({ type: SCVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/createscvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				dispatch({ type: SC_CREATE_VISUALISATION}); 
				if(resdata.status==1){
					allSCVisualisation('')(dispatch);
					NotificationManager.success(resdata.message);
				}else{
					NotificationManager.error(resdata.message);
				}
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}

export const deleteSCVisualisation = (id) => async (dispatch) => {
	
	var payload={
		"id":id
	}
	
	  dispatch({ type: SCVISUAL_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/deletescvisualisation', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				dispatch({ type: SC_VISUALISATION_DELETE}); 
				if(resdata.status==1){
					allSCVisualisation('')(dispatch);
					NotificationManager.success(resdata.message);
				}else{
					NotificationManager.error(resdata.message);
				}
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}



